import React, { FC } from 'react';
import { formatDate } from '@fiverr-private/futile';
import { dateTimeFormat, DATETIME_ELEMENT_STYLES } from '@fiverr-private/localization';
import { getContext, I18n } from '@fiverr-private/fiverr_context';

import TimeToRead from '../TimeToRead';
import CalendarSVG from './assets/calendar.svg';

import './index.scss';

interface LabelsProps {
  publishedDate: string;
  timeToRead?: number;
  author?: {
    authorName: string;
  };
}

const Labels: FC<LabelsProps> = ({ publishedDate, timeToRead, author = {} as any }) => {
  const { locale } = getContext();
  const { authorName } = author;

  return (
    <div className="labels">
      {authorName && (
        <div className="author-name">
          <I18n k="fiverr_guides.by" params={{ authorName }} />
        </div>
      )}
      <div>
        <img src={CalendarSVG} />
        {dateTimeFormat(new Date(publishedDate), {
          fallbackValue: formatDate(new Date(publishedDate), {
            locale,
            month: 'long',
          }),
          year: DATETIME_ELEMENT_STYLES.NUMERIC,
          month: DATETIME_ELEMENT_STYLES.LONG,
          day: DATETIME_ELEMENT_STYLES.NUMERIC,
        })}
      </div>
      {!!timeToRead && timeToRead > 0 && (
        <div>
          <TimeToRead timeToRead={timeToRead} />
        </div>
      )}
    </div>
  );
};

export default Labels;
